// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__25qFB","footer":"ModalCreateQualiphyProcedure_footer__3LmrY","additionData":"ModalCreateQualiphyProcedure_additionData__2SSGC"};